export const UPDATE_NUMBER_OF_ADULTS = 'templates/hotel/searchParameters/selectRooms/UPDATE_NUMBER_OF_ADULTS';
export const UPDATE_NUMBER_OF_CHILDREN = 'templates/hotel/searchParameters/selectRooms/UPDATE_NUMBER_OF_CHILDREN';
export const UPDATE_CHILD_AGE = 'templates/hotel/searchParameters/selectRooms/UPDATE_CHILD_AGE';
export const ADD_ROOM = 'templates/hotel/searchParameters/selectRooms/ADD_ROOM';
export const REMOVE_ROOM = 'templates/hotel/searchParameters/selectRooms/REMOVE_ROOM';
export const REMOVE_ROOM_AT_INDEX = 'templates/hotel/searchParameters/selectRooms/REMOVE_ROOM_AT_INDEX';
export const SET_ROOMS = 'templates/hotel/searchParameters/selectRooms/SET_ROOMS';
